import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Location } from 'models/locations';

import CurrencySymbol from 'components/common/currency-symbol';

const propTypes = {
  child: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  Icon: PropTypes.func,
  isTotalRow: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
  opacity: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  valuePrefix: PropTypes.string,
};

const defaultProps = {
  child: null,
  Icon: null,
  isTotalRow: false,
  opacity: '100',
  valuePrefix: null,
};

class CheckoutSummaryLineItem extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    if (this.props.child) {
      this.setState({
        expanded: !this.state.expanded,
      });
    }
  }

  renderValue() {
    const { location, value, valuePrefix } = this.props;

    const prefix = Number(value) < 0 ? '-' : valuePrefix;

    return (
      <span>
        {prefix}
        <CurrencySymbol location={location} />
        {Math.abs(value).toFixed(2)}
      </span>
    );
  }

  render() {
    const { child, Icon, isTotalRow, label, opacity } = this.props;
    const { expanded } = this.state;

    const commonTextStyles = `text-weight-book text-color-dark-slate opacity-${opacity}`;
    const commonValueStyles = 'col-xs-5 col-print-7 col-gutter-left-0 text-align-right';

    const labelStyles = cx(commonTextStyles, 'float-left', {
      'text-size-sm-16 text-size-xs-14': !isTotalRow,
      'text-size-sm-24 text-size-xs-16': isTotalRow,
      'clickable': child,
    });

    const iconStyles = cx('checkout-summary-icon', {
      'opacity-100': expanded,
      'opacity-50': !expanded,
    });

    const valueStyles = cx(commonTextStyles, commonValueStyles, {
      'text-size-sm-16 text-size-xs-14': !isTotalRow,
      'text-size-sm-24 text-size-xs-20 text-weight-bold': isTotalRow,
    });

    const containerStyles = cx('row', {
      'margin-top-10': !isTotalRow,
    });

    return (
      <Fragment>
        <div className={containerStyles}>
          <div onClick={this.handleToggle} className="col-xs-7 col-print-5 col-gutter-right-0">
            <div className={labelStyles}>{label}</div>
            {Icon && (
              <div className={iconStyles}>
                <Icon />
              </div>
            )}
          </div>
          <div className={valueStyles}>
            {this.renderValue()}
          </div>
        </div>
        <div className="text-weight-medium text-color-dark-slate text-size-sm-14 text-size-xs-12">
          {this.state.expanded && child}
        </div>
      </Fragment>
    );
  }
}

CheckoutSummaryLineItem.propTypes = propTypes;
CheckoutSummaryLineItem.defaultProps = defaultProps;

export default CheckoutSummaryLineItem;
